import React, { useState } from 'react'
import InputArea from './inputArea'
import TODOITEM from './TODOITEM';


const App = () => {
  const [items,setItems] = useState([])

const addItem =(item)=>{
  setItems((currItems)=>{
    // ... is javascript es6 sprid operator
    return[...currItems,item];
});
}
const deleteItem =(id)=>{
  setItems((currItems)=>{
    let tempArr =currItems.filter((item,index)=>{
      return index !==id;
    });
    return tempArr;
  })
}
  return (
    <div className="app">
      <h1 className="app_title">TO-DO-LIST</h1>
      <div className=" itemsContainer">
      <InputArea addItem={addItem}/>
      {items.length === 0 ? (
        <h1 style={{textAlign:"center"}}>NO ITEMS IS ADDED </h1>
      ) :(
        items.map((item,index)=>{
          return  <TODOITEM itemText={item} deleteItem={()=>deleteItem(index)}/>
        })
      )}
      </div>
    </div>
  )
}

export default App